import { GenericSchedule, PickupTypePlan, AvailableDayAndService, ErrorSchedule } from "../../interface/upplm.pickupdetails";

export class PickupDetailsSession {
    pickupType: string;
    saturdayToogle: boolean;
    allSchedule: GenericSchedule[];
    pPlanTypes: PickupTypePlan[];
    availableDays: AvailableDayAndService[];
    errors: ErrorSchedule[];
    showPageEdit: boolean;
}